const IConstants = {
    MYSHARED: "myShared",
    OWNED: "owned",
    SHAREDWITHME: "sharedWithMe"
}

export default IConstants